module.exports = __webpack_public_path__ + "img/ripple.c995d571.jpg";